import { useMemo } from 'react';
import { useApi } from '@/api/useApi';
import { useQueryProvider } from '@/hooks';
import { QUERY_KEYS } from '@/constants/QueryKeys';
import { mapExpertEventType } from '../boutique-classroom.mappers';
import { EVENT_TYPES_REQUEST_PARAMS } from '../boutique-classroom.constants';
import { ExpertEventType } from '../boutique-classroom.types';

const EMPTY_TYPES: ExpertEventType[] = [];

export function useExpertEventTypes() {
	const { ExpertControllerApi } = useApi();

	const { data, isLoading } = useQueryProvider(
		[QUERY_KEYS.getSelectableEventTypes, EVENT_TYPES_REQUEST_PARAMS.isGroupEvent],
		() => ExpertControllerApi.getSelectableEventTypes(EVENT_TYPES_REQUEST_PARAMS.isGroupEvent),
		{
			select: ({ data: response }) => response?.data ?? [],
			refetchOnWindowFocus: false
		}
	);

	const eventTypes = useMemo<ExpertEventType[]>(() => (data ?? []).map(mapExpertEventType).filter((type): type is ExpertEventType => type !== null), [data]);

	return { eventTypes: eventTypes.length ? eventTypes : EMPTY_TYPES, isLoading };
}
